//Class Constructor
//This call usually is made in the Views, and there are the parameters specified.
NHS.Scripts.CommunityDetailXp = function (parameters) {
  //Initializing parameters
  this.parameters = parameters;
  this._tabsControlId = parameters.tabsControlId;
  this._searchParameters = parameters.searchParameters;
  this._getHomeResultsByCommunityFromApi = parameters.getHomeResultsByCommunityFromApi;
  this.selectedTab = parameters.SelectedTab;
  this._communityId = parameters.communityId;
  this._builderId = parameters.builderId;
  this.player = null;
  this.numberOfCards = 9;
  this.communityDetailContainerHigh = undefined;
  this.logger = new NHS.Scripts.Globals.EventLogger({
    siteRoot: parameters.logInfo.siteRoot,
    fromPage: parameters.logInfo.fromPage,
    partnerID: parameters.logInfo.partnerId,
    partnerName: parameters.logInfo.partnerName,
    performanceLogUrl: parameters.logInfo.performanceLogUrl,
    marketId: parameters.marketId
  });

  this.favs = new NHS.Scripts.Favorites({
    urlBase: parameters.urlBase,
    partnerId: parameters.PartnerId,
    marketId: parameters.MarketId,
    logInfo: parameters.logInfo
  });
};

NHS.Scripts.CommunityDetailXp.prototype = {
  get_commId: function () {
    return this._communityId;
  },
  get_builderId: function () {
    return this._builderId;
  },
  initialize: function () {
    var self = this;
    self.setUpControls();
    self.favs.init();

    const loadReviews = function() {
      const ratingsFlagElement = document.querySelector('#IsReviewsAvailable');
      const hasReviews = ratingsFlagElement && ratingsFlagElement.value === 'True';

      if (hasReviews) {
        const microModalInput = document.querySelector('#ratings-bundle');

        NHS.loadJs(microModalInput.value, "ratings-script", function () {
          RatingsAndReviews.loadDetailSection();
        });
      }
    }

    var attributeParameters = self.parameters;
    if (attributeParameters.mapParameters) {
      attributeParameters.mapParameters.logger = new NHS.Scripts.Globals.EventLogger({
        siteRoot: self.parameters.logInfo.siteRoot,
        partnerId: self.parameters.logInfo.partnerId,
        partnerName: self.parameters.logInfo.partnerName,
        marketId: self.parameters.logInfo.marketId,
        performanceLogUrl: self.parameters.logInfo.performanceLogUrl
      });
    }


    if (document.querySelectorAll("#HomesAndPlans").length !== 0) {
      defaultTargetForLazyLoad = "HomesAndPlans";
    } else {
      defaultTargetForLazyLoad = "CommunityInfo";
    }

    var mapsContainer = document.querySelector("#nhs_PropertyMap");
    self.googlePropertyMap = new NHS.Scripts.GooglePropertyMap(attributeParameters.mapParameters);
    self.googlePropertyMap.SetUpdate();

    function loadInteractiveMap(event) {
      self.googlePropertyMap.init();
      mapsContainer.removeEventListener("click", loadInteractiveMap);
    }

    if (mapsContainer) {
      mapsContainer.addEventListener("click", loadInteractiveMap);
    }
    
    var testimonialsModel = {
      communityId: self.parameters.communityId,
      builderId: self.parameters.builderId,
      isMpCommunity: false,
      isPreview: self.parameters.PreviewMode === "True"
    };
    const nearbyWrapper = document.querySelector('[data-nearby-wrapper]');
    if (nearbyWrapper !== null) {
      self.performLazyLoad('nhs_nearbyHomesSection', null, nearbyWrapper.dataset.url, function (data) {
        if (!data) {
          const nearbySection = document.querySelector('[data-nearby-section]');
          nearbySection.setAttribute('hidden', '');
          return;
        }

        document.querySelector('[data-nearby-wrapper]').innerHTML = data;
        self.favs.init();
        document.body.dispatchEvent(new CustomEvent('moreCommunitiesLoaded'));
      });
    }
    self.performLazyLoad(defaultTargetForLazyLoad, testimonialsModel, self.parameters.getCommunityTestimonialsUrl, function (data) {
      var container = document.createElement("div");
      var testimonialsData = data.Testimonials;
      var testimonialsCards = document.querySelector(".card__testimonials");
      var testimonialContainer = document.querySelector(".section__testimonials");
      if (testimonialsData.length > 0) {
        if (testimonialsCards && testimonialContainer) {
          for (var i = 0; i < testimonialsData.length; i++) {
            var cloneTestimonialCard = testimonialsCards.cloneNode(true);
            cloneTestimonialCard.querySelector(".testimonial__text").innerHTML =
              testimonialsData[i].Description;
            cloneTestimonialCard.querySelector(".testimonial__citation").innerHTML =
              testimonialsData[i].Citation;
            container.appendChild(cloneTestimonialCard);
          }
          testimonialContainer.innerHTML = container.innerHTML;
          document.querySelector(".testimonial__section").style.display = 'block';
        }
      }
    });

    self._updateAdsPosition();

    loadReviews();

    new window.NewHomeSource.Modules.ArrowHandler({
      container: document.querySelector('[data-toolbar]')
    });

    // Arrow Handler for Sticky Bar
    new window.NewHomeSource.Modules.ArrowHandler({
      container: document.querySelector('[data-sticky-bar]')
    });


    const mapButton = document.querySelector('.nhs_FormMapLink');
    if (mapButton) {
      mapButton.addEventListener('click', (event) => {
        event.preventDefault();
        const neighborhoodStickyButton = document.querySelector('[data-id="nhs_MapsAndDirections"]');
        if (neighborhoodStickyButton) {
          neighborhoodStickyButton.click();
        }
      });
    }

    self.googleAnalyticsBindings();
    self.performanceEventsBindings();

    var container = document.querySelector("#nhs_DetailSalesOffice [data-slider-component]");

    /**
     * trackReadMoreOfferEvent: tracks the event when the read more button is clicked.
     * @param {string} readMoreButtonText word that is used on the read more button.
     */
    function trackReadMoreOfferEvent(readMoreButtonText){
      const googleAnalyticsEvent = {
        eventType: 'GA4Event',
        eventName: 'builder_deals',
        params: {
          click_target: readMoreButtonText
        }
      };
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: googleAnalyticsEvent }
      }));
    }

    var readOffersContainer = document.querySelector("[data-offersContainer]");
    if (readOffersContainer) {
      var offerBubblesCollection = document.querySelectorAll("[data-offerBubble]");
      var currentReadMoreText = "";
      var showHiddenContentClass = "offer__show";
      var showMoreElement;
      var collapsibleContentElement;
      readOffersContainer.addEventListener("click", function (event) {
        //If read more, we should change the text
        if (event.target.hasAttribute("data-readMoreOffer")) {
          for (var counter = 0; counter < offerBubblesCollection.length; counter++) {
            collapsibleContentElement = offerBubblesCollection[counter].querySelector("[data-collapsedContent]");
            if (collapsibleContentElement) {
              if (collapsibleContentElement.classList.contains(showHiddenContentClass)) {
                collapsibleContentElement.classList.remove(showHiddenContentClass);
              } else {
                collapsibleContentElement.classList.add(showHiddenContentClass);
              }
            }

            showMoreElement = offerBubblesCollection[counter].querySelector("[data-readMoreOffer]");
            if (showMoreElement) {
              currentReadMoreText = showMoreElement.textContent;
              showMoreElement.textContent = showMoreElement.getAttribute("data-toggleText");
              showMoreElement.setAttribute("data-toggleText", currentReadMoreText);

              const currentEventReadMoreText = showMoreElement.dataset.eventCurrentText;
              const currentEventReadMoreToggleText = showMoreElement.dataset.eventToggleText;
              showMoreElement.dataset.eventCurrentText = currentEventReadMoreToggleText;
              showMoreElement.dataset.eventToggleText = currentEventReadMoreText;
              trackReadMoreOfferEvent(currentEventReadMoreText);
            }

          }
        }
      });
    }

    //sticky bar detail pages scroll
    var scrollToBarItems = document.querySelectorAll('[page-scroller]');
    var scrollBehavior = 'scrollBehavior' in document.documentElement.style;
    for (var i = 0; i < scrollToBarItems.length; i++) {
      scrollToBarItems[i].addEventListener("click", function (event) {
        if (window.scroll) {
          event.preventDefault();
          var target = document.getElementById(this.getAttribute("data-target"));
          var selectedTab = document.querySelector("[class*=nhs-n1-c-button--nav-light-active]");
          if (target) {
            if (scrollBehavior) {
              target.scrollIntoView({ behavior: "smooth"});
            } else {
              target.scrollIntoView();
            }
            var targetElement = event.target;
            if (selectedTab && targetElement.hasAttribute("data-sticky-tab")) {
              selectedTab.classList.remove("nhs-n1-c-button--nav-light-active");
              delete selectedTab.dataset.itemActive;
              targetElement.classList.add("nhs-n1-c-button--nav-light-active");
              targetElement.dataset.itemActive = 'true';
            }
          }

        }
      });
    }
  },

  /**
   * Performs a Lazy load on a specific element and it will perform an ajax also.
   * @param {Number} idOfVisibleElement Id of the element that is present and also the one that will be the target to load.
   * @param {Any} dataForAjax Data that will be Stringified to a JSON on the AJAX call.
   * @param {String} urlForAjax Url where the AJAX call will hit.
   * @param {Function} successAjaxFunction Function that will be executed once the AJAX is success.
   */
  performLazyLoad: function (idOfVisibleElement, dataForAjax, urlForAjax, successAjaxFunction) {
    var lazyLoadReady = false;
    jQuery.LazyLoad({
      ElementVisibleId: idOfVisibleElement,
      UpdateAction: function (isVisible) {
        if (isVisible && lazyLoadReady === false) {
          lazyLoadReady = true;
          jQuery.ajax({
            url: urlForAjax,
            type: dataForAjax !== null ? "POST" : "GET",
            contentType: 'application/json',
            data: JSON.stringify(dataForAjax),
            success: successAjaxFunction
          });
        }
      }
    });
  },

  setUpControls: function () {
    const homesAndPlansJs = document.querySelector('#nhs_HomesAndPlans');

    if (homesAndPlansJs) {
      NHS.loadJs(homesAndPlansJs.value, 'homeAndPlans');
    }

    function backToTop(event) {
      event.preventDefault();
      document.body.scrollIntoView({behavior: "smooth"});
    }

    const topLinks = document.querySelectorAll('a[href="#top"]');
    topLinks.forEach(element => {
      element.addEventListener('click', backToTop);
    });
  },

  SetupNearbyCommunities: function (parameters) {
    if (this.googlePropertyMap.isMapCreate) {
      this.googlePropertyMap.googleApi.processResult(parameters);
      //this.googlePropertyMap.googleApi.AutoFit();
    } else {
      this.googlePropertyMap.parameters.NearbyComms = parameters;
    }
    this.favs.init();
  },

  SaveCommunity: function () {
    var self = this;
    var dataForPost = {
      communityId: self.parameters.communityId,
      builderId: self.parameters.builderId
    };
    jQuery.post(self.parameters.addCommunityToPlanerMethod, dataForPost, (function (json) {
      self.ShowSuccessMessage(json);
      if (json.data) {
        jQuery("a#nhs_SaveThisItem").replaceWith('<span id="nhs_SaveThisItem">' + self.parameters.SavedText + "</span>");
        //jQuery("#pSaveThisItem").html('<span class="nhs_ItemSaved" id="nhs_NextStepsSaveThisItem">' + self.parameters.SavedToYourProfileText + "</span>");
        jQuery("p #nhs_NextStepsSaveThisItem").addClass("nhs_ItemSaved").text(self.parameters.SavedText).removeAttr("onclick").removeAttr("href");
        jQuery("#pSaveThisItemMpc").html("<a class='nhs_Saved'><i class='fa fa-heart'></i><strong>" + self.parameters.SavedToYourProfileText + "</strong> <br /> Create an account and save your favorite homes, communities and developments</a>");
        jQuery("a#nhs_Saved").replaceWith("<span class='nhs_Save nhs_Saved'>" + self.parameters.SavedText + "</span>");
      }
    }).bind(this), "json");
  },

  ShowSuccessMessage: function (json) {
    var self = this;
    if (!json.data) {
      window.location.href = json.redirectUrl;
    } else {
      if (json.message === self.parameters.saveMessage) {
        //jQuery("#nhs_SaveThisItem").hide();
        jQuery("a#nhs_SaveThisItem").replaceWith("<a><span id='nhs_SaveThisItem'></span></a>");
        jQuery("#SuccessMessage").show();

      } else {
        jQuery("span#nhs_SaveThisItem").replaceWith("<a id='nhs_SaveThisItem'>" + self.parameters.SaveToFavoritesText + "</a>");
        jQuery("span.nhs_Save.nhs_Saved").replaceWith("<a id='nhs_Saved' class='nhs_Save'>" + self.parameters.SaveText + "</a>");
        jQuery("a#nhs_SaveThisItem, a#nhs_Saved").on("click", function () {
          self.SaveCommunity();
        });
      }
    }
  },

  googleAnalyticsBindings: function () {
    NHS.Scripts.Helper.createCookie("CTAName", "Community – CTA On Page Lead Form");
    const mainCta = document.querySelector('#nhs_GetBrochure');
    mainCta.addEventListener('click', function() {
      NHS.loadCss(document.getElementById("detailsXpRecosCss").value);
    });
  },
  performanceEventsBindings: function () {
    var self = this;
    const socialLinks = document.querySelectorAll('[data-share-link]');
    socialLinks.forEach(link => {
      window.NewHomeSource.Analytics.TdvTracker.buildTagWithEvent(link,
        'bcSocialShare,'+self.parameters.CommunityDetailSocialMediaShare,
        [
          {
            name: 'data-community',
            value: commDetail.get_commId()
          },
          {
            name: 'data-builder',
            value: commDetail.get_builderId()
          },
          {
            name: 'data-market',
            value: self.parameters.marketId
          },
      ])
    });
  },

  _updateAdsPosition: function () {
    var container;
    var detailInfo = document.querySelector(".nhs_DetailMain:not(.nhs_First)");
    var adCol = document.querySelector("#nhs_AdColumn");
    var salesoffice = document.getElementById("nhs_DetailSalesOffice");
    var homeToolsBuyingSection = document.querySelector(".nhs_ResToolsSection");
    var merchandizedSection = document.querySelector("#nhs_Merchandized_Reviews");
    var merchandizedSectionHeigth = 0;
    var homeToolsBuyingSectionHeight = 0;
    var salesOfficeHeight = 0;
    var heightToMinus = 0;

    if (salesoffice) {
      salesOfficeHeight = salesoffice.getBoundingClientRect().height;
    }
    if (homeToolsBuyingSection) {
      homeToolsBuyingSectionHeight = homeToolsBuyingSection.getBoundingClientRect().height;
    }
    if (merchandizedSection) {
      merchandizedSectionHeigth = merchandizedSection.getBoundingClientRect().height;
    }

    heightToMinus = salesOfficeHeight + homeToolsBuyingSectionHeight + merchandizedSectionHeigth;

    if (adCol) {
      container = adCol.querySelector("div");
    }
    if (!detailInfo || !adCol || !container || typeof window.MutationObserver === "undefined") return;

    container.setAttribute("style", "position: -webkit-sticky; position: sticky; top: 0; right: 0;");

    // The Height of the nhs_ResAdCol will change according to the height of the results
    // and the function above will be executed anytime the results change
  },
};

/*Show floating form when is collapse*/
var takeATourFloatingButton = document.querySelector("[data-take-tour]");
var floatingFormContainerHide = " ";
if (takeATourFloatingButton) {
  takeATourFloatingButton.addEventListener("click", function () {
    floatingFormContainerHide = document.querySelector("[data-floating-form-container]");
    if (floatingFormContainerHide) {
      floatingFormContainerHide.classList.remove("minimize");
    }
  });
}

/*Clean commentFloatingform when user request a In Person lead*/
var inPersonRequestLabel = document.querySelector("[data-text-in-person]");
if (inPersonRequestLabel) {
  inPersonRequestLabel.addEventListener("click",
    function () {
      var commentsInput = document.querySelector("#Comments_2");
      if (commentsInput)
        commentsInput.value = "";
    });
}

var commentInput = document.querySelector("#Comments_2");
if (commentInput) {
  var VirtualTourRequestLabel = document.querySelector("[data-is-virtual-tour]");
  if (VirtualTourRequestLabel) {
    VirtualTourRequestLabel.addEventListener("click",
      function () {
        var commentsInput = document.querySelector("#Comments_2");
        if (commentsInput)
          commentsInput.value = commentInput.value;
      });
  }
}

document.addEventListener("readystatechange", function () {
  if (document.readyState === "complete") {
    if (window.NewHomeSource.ElementToggler) {
      window.NewHomeSource.ElementToggler.Init();
    }

    if (window.NewHomeSource.CommunityAndNeighBorhoodHandler) {
      window.NewHomeSource.CommunityAndNeighBorhoodHandler.init();
    }

    if (window.NewHomeSource.InitialLoadModalHandler) {
      window.NewHomeSource.InitialLoadModalHandler.DisplayModal();
    }
  }
});

/*
 * When clicking in the header links that navigate to the different available homes tabs
 * we need to make sure the user sees the correct tab, we get this done by adding the data-available-homes
 * attribute to the header link with the value being the element ID of the correct tab in the 
 * available homes section.
*/
(function () {
  document.addEventListener('click', function (event) {
    if (event.target.hasAttribute('data-available-homes')) {
      const targetElementId = event.target.getAttribute('data-available-homes');
      const targetElement = document.getElementById(targetElementId);

      if (targetElement) {
        targetElement.click();
      } else {
        const alernateTargetElementId = event.target.getAttribute('data-available-homes-alternate');
        const alternateTargetElement = document.getElementById(alernateTargetElementId);

        if (alternateTargetElement) {
          alternateTargetElement.click();
        }
      }
    }
  })
}());

/*
 * When clicking in the price reduction label on the top of the page, that action should take the
 * user to the homes and plans section. We can't do this via an anchor targeting an #id in the page
 * since we have a base tag pointing to the homepage (not the detail page itself), so creating an
 * anchor tag with href="#id" will take you to the homepage and look for the #id there.
*/
(function () {
  const priceReductionLabel = document.getElementById('nhs_priceReductionLabel');
  const trustBuilderReviewsSection = document.querySelector('[data-detail-reviews-section]');

  const homesAndPlansSection = document.getElementById('HomesAndPlans');
  const builderSection = document.getElementById('builderInfoSection');

  if (priceReductionLabel && homesAndPlansSection) {
    priceReductionLabel.addEventListener('click', function () {
      homesAndPlansSection.scrollIntoView();
    });
  }

  if (trustBuilderReviewsSection && builderSection) {
    trustBuilderReviewsSection.addEventListener('click', function (event) {
       event.preventDefault();
       builderSection.scrollIntoView();
    });
  }
}());